"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilIconChevronRight = void 0;
var react_1 = __importDefault(require("react"));
var IconBase_1 = __importDefault(require("../IconBase"));
var utils_1 = require("../utils");
var NavigateNext = function (props) { return (react_1.default.createElement(IconBase_1.default, __assign({}, props),
    react_1.default.createElement("path", { d: "M17.5606 13.0588C18.1464 12.473 18.1464 11.5233 17.5606 10.9375L9.78246 3.15931C9.19668 2.57352 8.24693 2.57352 7.66114 3.15931C7.07536 3.7451 7.07536 4.69484 7.66114 5.28063L14.3787 11.9981L7.66114 18.7157C7.07536 19.3014 7.07536 20.2512 7.66114 20.837C8.24693 21.4228 9.19668 21.4228 9.78246 20.837L17.5606 13.0588Z" }))); };
exports.UtilIconChevronRight = (0, utils_1.withDeprecationWarning)(NavigateNext, 'UtilIconChevronRight');
exports.default = NavigateNext;
